// services/baseService.js
import axios from 'axios';
import { stateStore } from '../store/stateStore';
const BASE_URL = process.env.REACT_APP_API_ENDPOINT_URL || 'http://localhost:3001/api'; // URL chung cho API

// Hàm gọi API cơ bản
const baseFetch = async (url, options = {}) => {
  const { setLoading, setError} = stateStore.getState()
  try {
    setLoading(true)
    const token = localStorage.getItem('token');

    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    };


    const response = await axios({
      url,
      method: options.method || 'GET',
      data: options.body || null,
      params: options.params || null,
      headers,
    });

    return { data: response.data, error: null };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Something went wrong';
    setError(errorMessage)
    throw new Error(errorMessage); // Ném lỗi với thông báo cụ thể
  }
  finally {
    setLoading(false)
  }
};

// Các hàm CRUD
export const create = async (endpoint, body) => {
  return baseFetch(`${BASE_URL}/${endpoint}`, {
    method: 'POST',
    body,
  });
};

export const getAll = async (endpoint, params) => {
  return baseFetch(`${BASE_URL}/${endpoint}`, {
    method: 'GET',
    params,
  });
};

export const getById = async (endpoint, id) => {
  return baseFetch(`${BASE_URL}/${endpoint}/${id}`, {
    method: 'GET',
  });
};

export const update = async (endpoint, id, body) => {
  return baseFetch(`${BASE_URL}/${endpoint}/${id}`, {
    method: 'PUT',
    body,
  });
};

export const remove = async (endpoint, id) => {
  return baseFetch(`${BASE_URL}/${endpoint}/${id}`, {
    method: 'DELETE',
  });
};

// Hàm gọi API với tùy chỉnh
export const customFetch = async (endpoint, options = {}) => {
  return baseFetch(`${BASE_URL}/${endpoint}`, options);
};
